import React, { type PropsWithChildren } from 'react';

import styled from 'styled-components';

import { spacing } from '@sine/sine-ui-components';

export type IPageContentProps = PropsWithChildren<{
  /** Optionally place class on outer component. */
  className?: string;
  /** Whether to make the content full width. Defaults to `false`. */
  fullWidth?: boolean;
}>;

const Container = styled.div<Pick<IPageContentProps, 'fullWidth'>>`
  min-width: 350px;
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : '640px')};
  margin: 0 auto;
  padding: ${spacing(3)};
`;

export function PageContent({ className, fullWidth = false, children }: IPageContentProps) {
  return (
    <Container className={className} fullWidth={fullWidth} data-st-ext='page-content'>
      {children}
    </Container>
  );
}
